import ParentView from '@/components/ParentView'
import Router from 'vue-router'
// import store from '@/store'
import store from '@/store'
// import Nav from '@/views/Layout/Layout.vue'
// import LoginComponent from '@/views/login/index.vue'
// import Page404Component from '@/views/errorPage/404.vue'
// import DashboardComponent from '@/views/Dashboard/index.vue'
// import TaskComponent from '@/views/Tasks/index.vue'
// import TestComponent from '@/views/Tests/index.vue'
// import DemoComponent from '@/views/Demo/index.vue'
// import DetailComponent from '@/views/Details/index.vue'
// import CostComponent from '@/views/Cost/index.vue'
// import AdminComponent from '@/views/admin/index.vue'
// import OperationComponent from '@/views/Operation/index.vue'
import RobotComponent from '@/views/Robot/index.vue'
// import conponents
const Layout = () => import('@/views/Layout/Layout.vue')
const LoginComponent = () => import('@/views/login/index.vue')
const Page404Component = () => import('@/views/errorPage/404.vue')
const Middle = () => import('@/views/middle/index.vue')
const Dashboard = () => import('@/views/Dashboard/index.vue')
// const DashboardComponent = () => import('@/views/Dashboard/index.vue')
// const TaskComponent = () => import('@/views/Tasks/index.vue')
// const TestComponent = () => import('@/views/Tests/index.vue')
// const DemoComponent = () => import('@/views/Demo/index.vue')
const AddCallComponent = () => import('@/views/AddCall/index.vue')
const CallTasks = () => import('@/views/CallTasks/index.vue')
const tempCallTasks = () => import('@/views/Template/CallTasks/index.vue')
const SubCheckDetail = () => import('@/views/SubCheckDetail/index.vue')
const SubDetail = () => import('@/views/SubDetail/index.vue')
const SubCheckPlan = () => import('@/views/CallPlans/SubCheckPlan.vue')

const RobotExperience = () => import('@/views/Template/RobotExperience/index.vue')
const CallPlans = () => import('@/views/CallPlans/index.vue')
const DetailComponent = () => import('@/views/Details/index.vue')
const WebTalkComponent = () => import('@/views/Details/webtalk.vue')
// const CostComponent = () => import('@/views/Cost/index.vue')
// const AdminComponent = () => import('@/views/admin/index.vue')
const CallAssistant = () => import('@/views/CallAssistant/index.vue')
// const RobotComponent = () => import('@/views/Robot/index.vue')
// const PlanComponent = () => import('@/views/Plans/index.vue')
const StrategyComponent = () => import('@/views/Strategy/index.vue')
// const PromoteComponent = () => import('@/views/Promote/index.vue')
const DownloadTemp = () => import('@/components/uploadexcel/downTemp.vue')
const CrossLogin = () => import('@/views/Operation/crossLogin.vue')
const PersonalInfo = () => import('@/views/Personal/PersonalInfo/index.vue')
const LoginInfo = () => import('@/views/Personal/LoginInfo/index.vue')
const BlackList = () => import('@/views/Blacklist/index.vue')
const DemoPage = () => import('@/views/DemoSingle/index.vue')
const Workflow = () => import('@/views/WorkFlow/task.vue')
const WorkflowTemplate = () => import('@/views/WorkFlow/set.vue')
const WorkflowView = () => import('@/views/WorkFlow/DataOverview/index.vue')
const WorkflowChild = () => import('@/views/WorkFlow/childTask.vue')
const WorkflowVersion = () => import('@/views/WorkFlow/version.vue')
const WorkflowCalendar = () => import('@/views/WorkFlow/calendar.vue')
const Flow = () => import('@/views/WorkFlow/flow/index.vue')
const StageReport = () => import('@/views/StageReport/index.vue')
const SmsTemplate = () => import('@/views/Robot/mail.vue')
const WhatsappTemplate = () => import('@/views/Robot/app.vue')
const InboundDashboard = () => import('@/views/Inbound/Dashboard/index.vue')
const InboundRobotManage = () => import('@/views/Inbound/RobotManage/index.vue')
const CallRecords = () => import('@/views/Inbound/CallRecords/index.vue')
const ChatbotLiveMonitor = () => import('@/views/Chatbot/dashboard/liveMonitor/index.vue')
const ChatbotOverview = () => import('@/views/Chatbot/dashboard/overview/index.vue')
const ChatbotAnalysis = () => import('@/views/Chatbot/dashboard/analysis/index.vue')
const ChatbotCR = () => import('@/views/Chatbot/dashboard/record/index.vue')
const ChatbotSocialTest = () => import('@/views/Chatbot/social/test/index.vue')
const ChatbotSocial = () => import('@/views/Chatbot/social/index.vue')
const ChatbotReq = () => import('@/views/Chatbot/req/index.vue')
const ChatbotOnline = () => import('@/views/Chatbot/manage/online/index.vue')
const ChatbotWBTmpl = () => import('@/views/Chatbot/wbTmpl/index.vue')
const ChatbotWBTmplEdit = () => import('@/views/Chatbot/wbTmpl/edit.vue')
const ChatbotBroadcast = () => import('@/views/Chatbot/broadcast/index.vue')
const ChatbotTeamInbox = () => import('@/views/Chatbot/teamInbox/index.vue')
const ChatbotAPI = () => import('@/views/Chatbot/API/index.vue')
const ChatbotOptOut = () => import('@/views/Chatbot/opt-out/index.vue')
const ChatbotInsightsLiveMonitor = () => import('@/views/Chatbot/insights/liveMonitor/index.vue')
const AILogout = () => import('@/views/ailogout/index.vue')

// import PlanComponent from '@/views/Plans/index.vue'
// import StrategyComponent from '@/views/Strategy/index.vue'
// import PromoteComponent from '@/views/Promote/index.vue'
// create router object
export const constantRoutes = [
  {
    path: '/login',
    component: LoginComponent,
    hidden: true,
    name: 'login',
    meta: {
      noNeedLogin: true
    }
  },
  {
    path: '/ailogout',
    component: AILogout,
    hidden: true,
    name: 'ailogout',
    meta: {
      noNeedLogin: true
    }
  },
  {
    path: '/share',
    component: () => import('@/views/Template/RobotExperience/share.vue'),
    hidden: true,
    name: 'share',
    meta: {
      noNeedLogin: true
    }
  },
  {
    path: '/404',
    component: Page404Component,
    hidden: true,
    name: 'Page404',
    meta: { title: 'page404', noNeedLogin: true }
  },
  {
    path: '/downLoadTmep',
    hidden: true,
    name: 'DownLoadTmep',
    component: DownloadTemp,
    meta: {
      noNeedLogin: true
    }
  },
  // 中间页
  {
    path: '/middle/:page',
    component: Middle,
    hidden: true,
    name: 'middle',
    meta: {
      noNeedLogin: true
    }
  },
  {
    path: '/social-test',
    hidden: true,
    component: ChatbotSocialTest,
    meta: {
      noNeedLogin: true
    }
  },
  // 穿越登录
  {
    path: '/operation',
    hidden: true,
    component: Layout,
    redirect: '/operation/crossLogin',
    meta: { title: 'crossLogin', show: 'false' },
    children: [
      {
        path: 'crossLogin',
        name: 'crossLogin',
        component: CrossLogin,
        meta: {
          title: 'CrossLogin',
          roles: ['CrossLogin']
        }
      }
    ]
  },
  // 个人信息
  {
    path: '/userInfo',
    hidden: true,
    component: Layout,
    redirect: '/userInfo/personalInfo',
    children: [
      {
        path: 'personalInfo',
        name: 'personalInfo',
        component: PersonalInfo,
        meta: {
          title: 'personalInfo',
          roles: ['ic_strategy_page']
        }
      }
    ]
  },
  // 默认路由
  {
    path: '/',
    hidden: true,
    component: Layout,
    redirect: '/ai/dashboard'
  },
  // dashboard redirect to /ai/task/main
  {
    path: '/collection/Dashboard',
    hidden: true,
    component: Layout,
    redirect: '/ai/task/main'
  },
  // dashboard redirect to /ai/task/main
  {
    path: '/collection/detail',
    hidden: true,
    component: Layout,
    redirect: '/ai/detail'
  },
  {
    path: '/collection/task/main',
    hidden: true,
    component: Layout,
    redirect: '/ai/task/main'
  },
  {
    path: '/ai/account',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'balance',
        name: 'Account',
        component: () => import('@/views/Account/index.vue'),
        meta: {
          title: 'Account'
        }
      }
    ]
  },

  // { path: '*', hidden: true, redirect: '/404' }
]
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes,
  base: window.__POWERED_BY_QIANKUN__ ? '/subapp-calling' : ''
  // base: store.getters.mode ? '/aicc' : ''
})

const mode = { ai: 'normal' }
// const mode = { collection: 'normal', marketing: 'promotion', info_check: 'ic', cod: 'cod' }
let tempRoutes = []
for (let i in mode) {
  // console.log(`/${i}`)
  tempRoutes.push({
    path: `/${i}`,
    alwaysShow: true,
    name: 'collection',
    component: Layout,
    meta: { title: 'collection', businessType: mode[i], show: 'false' },
    children: [
      {
        path: 'robotExperience',
        component: RobotExperience,
        name: 'RobotExperience',

        meta: {
          icon: 'icon-jiqirentiyan',
          title: 'RobotExperience',
          roles: ['RobotExperience'],
          keepAlive: true
        },
        showChildren: 'false',
        noActiveSide: true,
        children: [
          {
            path: 'share',
            name: `${i}share`,
            hidden: true,
            component: () => import('@/views/Template/RobotExperience/batchShare.vue'),
            activeMenu: `/${i}/robotExperience`,
            meta: {
              title: 'batchShare',
              roles: ['RobotExperience'],
              keepAlive: true
            }
          },
          {
            path: 'shareLog',
            name: `${i}shareLog`,
            hidden: true,
            component: () => import('@/views/Template/RobotExperience/shareLog.vue'),
            activeMenu: `/${i}/robotExperience`,
            meta: {
              title: 'shareLog',
              roles: ['RobotExperience'],
              keepAlive: true,
              sub: true,
              showSub: true
            },
            showChildren: 'false',
            children: [
              {
                path: 'view',
                name: `${i}shareLogView`,
                hidden: true,
                component: () => import('@/views/Template/RobotExperience/shareLogView.vue'),
                activeMenu: `/${i}/robotExperience`,
                meta: {
                  title: 'viewData',
                  roles: ['RobotExperience'],
                  keepAlive: true,
                  sub: true,
                  showSub: true
                }
              }
            ]
          }
        ]
      },

      // {
      //   path: 'robotExperience/scenario',
      //   name: `${i}Scenario`,
      //   component: () => import('@/views/Template/RobotExperience/scenario.vue'),
      //   hidden: true,
      //   meta: {
      //     activeMenu: `/${i}/robotExperience`,
      //     roles: ['RobotExperience'],
      //     title: 'RobotExperience'
      //   }
      // },
      {
        path: `Dashboard`,
        name: `${i}Dashboard`,
        component: Dashboard,
        meta: {
          icon: 'icon-yibiaopan2',
          title: 'Dashboard',
          roles: ['Dashboard'],
          keepAlive: true
        }
      },
      {
        path: 'StageReport',
        name: 'StageReport',
        component: StageReport,
        meta: {
          icon: 'icon-jieduanbaogao2',
          title: 'StageReport',
          roles: ['StageReport'],
          keepAlive: true
        }
      },
      {
        // 最新 path： 任务相关的合并一起
        path: 'task',
        component: ParentView,
        meta: { title: 'AiCalling', icon: 'icon-hujiaoguanli1', show: 'false' },
        children: [
          {
            path: 'main',
            name: `${i}Tasks`,
            component: CallTasks,
            meta: {
              title: 'CallTasks',
              roles: ['CallTasks'],
              keepAlive: true
            }
          },
          {
            path: 'detail',
            name: `${i}Tasks`,
            component: SubDetail,
            meta: {
              title: 'SubDetail',
              sub: true,
              keepAlive: true
            }
          }
        ]
      },
      {
        path: 'call',
        component: ParentView,
        meta: { title: 'AiCalling', icon: 'icon-hujiaoguanli1', show: 'false' },
        children: [
          {
            path: 'details',
            component: ParentView,
            meta: { title: 'CallDetails', show: 'false' },
            children: [
              {
                path: '',
                name: `${i}CallDetails`,
                component: DetailComponent,
                meta: {
                  title: 'CallDetails',
                  roles: ['CallDetails'],
                  keepAlive: true
                }
              },
              {
                path: 'webtalk',
                name: `${i}WebTalk`,
                component: WebTalkComponent,
                meta: {
                  title: 'WebTalk',
                  roles: ['CallDetails'],
                  keepAlive: true
                }
              }
            ]
          },
          {
            path: 'BlackList',
            name: `${i}BlackList`,
            component: BlackList,
            meta: {
              title: 'BlackList',
              roles: ['BlackList'],
              keepAlive: true
            }
          },
          {
            path: 'CallAssistant',
            name: `${i}CallAssistant`,
            component: CallAssistant,
            meta: {
              title: 'CallAssistant',
              roles: ['CallAssistant'],
              keepAlive: true
            }
          }
        ]
      },
      {
        path: 'calling',
        component: ParentView,
        meta: { title: 'AiCalling', icon: 'icon-hujiaoguanli1', show: 'false' },
        children: [
          {
            path: 'tasks',
            name: `${i}Tasks`,
            component: CallTasks,
            meta: {
              title: 'CallTasks',
              roles: ['CallTasks'],
              keepAlive: true
            }
          },

          {
            path: 'plans',
            name: `${i}Plans`,
            component: CallPlans,
            meta: {
              title: 'CallPlans',
              roles: ['CallPlans'],
              keepAlive: true
            }
          },
          {
            path: 'CallStrategy',
            name: `${i}CallStrategy`,
            component: StrategyComponent,
            meta: {
              title: 'CallStrategy',
              roles: ['CallStrategy'],
              keepAlive: true
            }
          },
          {
            path: 'details',
            name: `${i}CallDetails`,
            component: DetailComponent,
            meta: {
              title: 'CallDetails',
              roles: ['CallDetails'],
              keepAlive: true
            }
          },
          {
            path: 'BlackList',
            name: `${i}BlackList`,
            component: BlackList,
            meta: {
              title: 'BlackList',
              roles: ['BlackList'],
              keepAlive: true
            }
          },
          {
            path: 'CallAssistant',
            name: `${i}CallAssistant`,
            component: CallAssistant,
            meta: {
              title: 'CallAssistant',
              roles: ['CallAssistant'],
              keepAlive: true
            }
          }
        ]
      },
      {
        // path: 'WorkFlow',
        // lxl-新路径
        path: 'AgentFlow',
        component: ParentView,
        meta: { title: 'WorkflowManage', icon: 'icon-workflowguanli1', show: 'false' },
        children: [
          {
            name: `${i}WorkflowTemplate`,
            path: 'WorkflowTemplate',
            component: WorkflowTemplate,
            meta: {
              title: 'WorkflowTemplate',
              roles: ['WorkflowTemplate'],
              keepAlive: true
            },
            showChildren: 'false',
            children: [
              {
                name: `${i}WorkflowVersion`,
                path: 'WorkflowVersion',
                component: WorkflowVersion,
                hidden: true,
                meta: {
                  // activeMenu: `/${i}/WorkFlow/WorkflowTemplate`,
                  // lxl-新路径
                  activeMenu: `/${i}/AgentFlow/WorkflowTemplate`,
                  roles: ['WorkflowTemplate'],
                  title: 'version',
                  keepAlive: true
                }
              },
              {
                name: `${i}WorkflowCalendar`,
                path: 'WorkflowCalendar',
                component: WorkflowCalendar,
                hidden: true,
                meta: {
                  // activeMenu: `/${i}/WorkFlow/WorkflowTemplate`,
                  // lxl-新路径
                  activeMenu: `/${i}/AgentFlow/WorkflowTemplate`,
                  roles: ['WorkflowTemplate'],
                  title: 'holiday',
                  keepAlive: true
                }
              },
              {
                path: 'flowEdit',
                name: `${i}flowEdit`,
                component: Flow,
                hidden: true,
                meta: {
                  // activeMenu: `/${i}/WorkFlow/WorkflowTemplate`,
                  // lxl-新路径
                  activeMenu: `/${i}/AgentFlow/WorkflowTemplate`,
                  roles: ['WorkflowTemplate'],
                  title: 'edit'
                }
              },
              {
                path: 'flowAdd',
                name: `${i}flowAdd`,
                component: Flow,
                hidden: true,
                meta: {
                  // activeMenu: `/${i}/WorkFlow/WorkflowTemplate`,
                  // lxl-新路径
                  activeMenu: `/${i}/AgentFlow/WorkflowTemplate`,
                  roles: ['WorkflowTemplate'],
                  title: 'add'
                }
              },
              {
                path: 'flowCopy',
                name: `${i}flowCopy`,
                component: Flow,
                hidden: true,
                meta: {
                  // activeMenu: `/${i}/WorkFlow/WorkflowTemplate`,
                  // lxl-新路径
                  activeMenu: `/${i}/AgentFlow/WorkflowTemplate`,
                  roles: ['WorkflowTemplate'],
                  title: 'copy'
                }
              },

              {
                path: 'flowInfo',
                name: `${i}flowInfo`,
                component: Flow,
                hidden: true,
                meta: {
                  // activeMenu: `/${i}/WorkFlow/WorkflowTemplate`,
                  // lxl-新路径
                  activeMenu: `/${i}/AgentFlow/WorkflowTemplate`,
                  roles: ['WorkflowTemplate'],
                  title: 'info'
                }
              }
            ]
          },
          {
            name: `${i}Workflow`,
            path: 'Workflow',
            component: Workflow,
            meta: {
              title: 'Workflow',
              roles: ['Workflow'],
              keepAlive: true
            },
            showChildren: 'false',
            children: [
              {
                name: `${i}WorkflowChild`,
                path: 'WorkflowChild',
                component: WorkflowChild,
                hidden: true,
                meta: {
                  // activeMenu: `/${i}/WorkFlow/Workflow`,
                  // lxl-新路径
                  activeMenu: `/${i}/AgentFlow/Workflow`,
                  roles: ['Workflow'],
                  title: 'child',
                  keepAlive: true,
                  sub: true,
                  showSub: true
                }
              },
              {
                path: 'flowCheck',
                name: `${i}flowCheck`,
                component: Flow,
                hidden: true,
                meta: {
                  // activeMenu: `/${i}/WorkFlow/WorkflowTemplate`,
                  // lxl-新路径
                  activeMenu: `/${i}/AgentFlow/WorkflowTemplate`,
                  roles: ['WorkflowTemplate'],
                  title: 'check',
                  keepAlive: true
                },
                showChildren: 'false',
                children: [
                  {
                    path: 'flowDataView',
                    name: `${i}flowview`,
                    component: WorkflowView,
                    hidden: true,
                    meta: {
                      // activeMenu: `/${i}/WorkFlow/WorkflowTemplate`,
                      // lxl-新路径
                      activeMenu: `/${i}/AgentFlow/WorkflowTemplate`,
                      roles: ['WorkflowTemplate'],
                      title: 'view'
                    }
                  }
                ]
              }
            ]
          },
          {
            path: 'dataView',
            name: `${i}dataview`,
            component: WorkflowView,
            showChildren: 'false',
            children: [],
            meta: {
              // activeMenu: `/${i}/WorkFlow/dataView`,
              // lxl-新路径
              activeMenu: `/${i}/AgentFlow/dataView`,
              roles: ['WorkflowDashboardPage'],
              title: 'view',
              keepAlive: true
            }
          }
        ]
      },
      {
        path: 'robot',
        component: ParentView,
        meta: {
          icon: 'icon-duoqudaoguanli',
          title: 'MultiChannelManager',
          show: 'false'
        },
        children: [
          {
            path: 'robotList',
            name: `${i}RobotList`,
            component: RobotComponent,
            meta: {
              title: 'RobotList',
              roles: ['RobotList'],
              keepAlive: true
            }
          },
          {
            path: 'robotDetail',
            name: `${i}RobotDetail`,
            component: () => import('@/views/Robot/robotDetail.vue'),
            hidden: true,
            meta: {
              activeMenu: `/${i}/robot/robotList`,
              roles: ['RobotList'],
              title: 'info'
            }
          },
          {
            path: 'addHangUpMessage',
            name: `${i}AddHangUpMessage`,
            component: () => import('@/views/Robot/addHangUpMessage.vue'),
            hidden: true,
            meta: {
              activeMenu: `/${i}/robot/robotList`,
              roles: ['RobotList'],
              title: 'info'
            }
          },
          {
            path: 'SmsTemplate',
            name: 'SmsTemplate',
            component: SmsTemplate,
            meta: {
              title: 'SmsTemplate',
              roles: ['SmsTemplate'],
              keepAlive: true
            },
            showChildren: 'false',
            children: []
          },
          {
            path: 'WhatsappTemplate',
            name: 'WhatsappTemplate',
            component: WhatsappTemplate,
            meta: {
              title: 'WhatsappTemplate',
              roles: ['WhatsappTemplate'],
              keepAlive: true
            },
            showChildren: 'false',
            children: []
          }
        ]
      },
      {
        path: 'detail',
        name: `${i}SubDetail`,
        hidden: true,
        component: SubDetail,
        meta: {
          sub: true,
          keepAlive: true
        }
      },
      {
        path: 'subCheckDetail',
        name: `${i}SubCheckDetail`,
        hidden: true,
        component: SubCheckDetail,
        meta: {
          sub: true,
          keepAlive: true
        }
      },
      {
        path: 'subCheckPlan',
        name: `${i}SubCheckPlan`,
        hidden: true,
        component: SubCheckPlan,
        meta: {
          sub: true,
          keepAlive: true
        }
      }
    ]
  })
}
tempRoutes.push(
  // 体验版
  {
    path: '/template',
    alwaysShow: true,
    name: 'template',
    component: Layout,
    meta: { title: 'template', businessType: '', show: 'false' },
    children: [
      {
        path: 'robotExperience',
        component: RobotExperience,
        name: 'RobotExperience',
        meta: {
          icon: 'icon-jiqirentiyan',
          title: 'RobotExperience',
          keepAlive: true
        }
      },
      {
        path: 'robotExperience/scenario',
        name: 'templateScenario',
        component: () => import('@/views/Template/RobotExperience/scenario.vue'),
        hidden: true,
        meta: {
          activeMenu: '/template/robotExperience',
          title: 'RobotExperience',
          keepAlive: true
        }
      },
      {
        path: 'tempCalling',
        component: ParentView,
        meta: { title: 'AiCalling', icon: 'icon-hujiaoguanli1', show: 'false' },
        children: [
          {
            path: 'tempCallTasks',
            name: 'TempCallTasks',
            component: tempCallTasks,
            meta: {
              title: 'CallTasks',
              keepAlive: true
            }
          }
        ]
      }
    ]
  },
  // calling运营
  {
    path: '/CallingOperation',
    alwaysShow: true,
    name: 'CallingOperation',
    component: Layout,
    meta: { title: 'CallingOperation', businessType: 'operating', show: 'false' },
    children: [
      {
        path: 'outbound',
        component: ParentView,

        meta: { title: 'operationOutbound', icon: 'icon-hujiaoguanli1', show: 'false' },
        children: [
          {
            path: 'SingleTest',
            name: 'SingleTest',
            component: DemoPage,
            meta: {
              title: 'SingleTest',
              roles: ['SingleTest'],
              keepAlive: true
            }
          },
          {
            path: 'OPERsubDetail',
            name: 'OPERSubDetail',
            hidden: true,
            component: SubDetail,
            meta: {
              sub: true,
              keepAlive: true
            }
          },
          {
            path: 'OPERsubCheckDetail',
            name: 'OPERSubCheckDetail',
            hidden: true,
            component: SubCheckDetail,
            meta: {
              sub: true,
              keepAlive: true
            }
          },
          {
            path: 'OPERsubCheckPlan',
            name: 'OPERSubCheckPlan',
            hidden: true,
            component: SubCheckPlan,
            meta: {
              sub: true,
              keepAlive: true
            }
          },
          {
            path: 'AddCall',
            component: AddCallComponent,
            meta: {
              title: 'AddCall',
              roles: ['AddCall']
            }
          }
        ]
      }
    ]
  },
  // inbound
  {
    path: '/Inbound',
    alwaysShow: true,
    name: 'Inbound',
    component: Layout,
    meta: { title: 'Inbound', businessType: 'Inbound', show: 'false' },
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: InboundDashboard,
        meta: {
          icon: 'icon-yibiaopan2',
          title: 'Dashboard',
          roles: ['InboundDashboard'],
          keepAlive: true
        }
      },
      {
        path: 'robotManage',
        name: 'robotManage',
        component: InboundRobotManage,
        meta: {
          icon: 'icon-jiqirentiyan',
          title: 'RobotManage',
          roles: ['InboundRobotManage'],
          keepAlive: true
        }
      },
      {
        path: 'callRecords',
        name: 'callRecords',
        component: CallRecords,
        meta: {
          icon: 'icon-hujiaoguanli1',
          title: 'CallLog',
          roles: ['InboundCallRecords'],
          keepAlive: true
        }
      }
    ]
  },
  // chatbot
  {
    path: '/chatbot',
    component: Layout,
    name: 'chatbot',
    alwaysShow: true,
    meta: { title: 'chatbot', businessType: 'chatbot', show: 'false' },
    children: [
      {
        path: 'dashboard',
        component: ParentView,
        meta: {
          title: 'Dashboard',
          icon: 'icon-yibiaopan2',
          show: 'false',
          roles: ['Dashboard']
        },
        children: [
          {
            path: 'liveMonitor',
            name: 'ChatbotLiveMonitor',
            component: ChatbotLiveMonitor,
            meta: {
              title: 'ChatbotLiveMonitor',
              keepAlive: true,
              roles: ['ChatbotLiveMonitor']
            }
          },
          {
            path: 'overview',
            name: 'ChatbotOverview',
            component: ChatbotOverview,
            meta: {
              title: 'ChatbotOverview',
              keepAlive: true,
              roles: ['ChatbotOverview']
            }
          },
          {
            path: 'analysis',
            name: 'ChatbotAnalysis',
            component: ChatbotAnalysis,
            meta: {
              title: 'ChatbotAnalysis',
              keepAlive: true,
              roles: ['ChatbotAnalysis']
            }
          },
          {
            path: 'record',
            name: 'ChatbotCR',
            component: ChatbotCR,
            meta: {
              title: 'ChatbotCR',
              keepAlive: true,
              roles: ['ChatbotCR']
            }
          }
        ]
      },
      {
        path: 'insights',
        component: ParentView,
        meta: {
          title: 'Insights',
          icon: 'icon-a-BotDashboard',
          show: 'false',
          roles: ['ChatbotInsights']
        },
        children: [
          {
            path: 'liveMonitor',
            name: 'ChatbotInsightsLiveMonitor',
            component: ChatbotInsightsLiveMonitor,
            meta: {
              title: 'ChatbotInsightsLiveMonitor',
              keepAlive: true,
              roles: ['ChatbotInsightsLiveMonitor']
            }
          }

        ]
      },
      {
        path: 'manage',
        component: ParentView,
        meta: {
          title: 'ChatbotManage',
          icon: 'icon-jiqiren',
          show: 'false',
          roles: ['ChatbotManage']
        },
        children: [
          {
            path: 'online',
            name: 'ChatbotOnline',
            component: ChatbotOnline,
            meta: {
              title: 'ChatbotOnline',
              keepAlive: true,
              roles: ['ChatbotOnline']
            }
          }
        ]
      },
      {
        path: 'MAB',
        component: ParentView,
        meta: {
          title: 'ChatbotMAB',
          icon: 'icon-yingxiao',
          show: 'false'
        },
        children: [
          {
            path: 'broadcast',
            name: 'ChatbotBroadcast',
            component: ChatbotBroadcast,
            meta: {
              title: 'ChatbotBroadcast',
              keepAlive: true,
              roles: ['ChatbotBroadcast']
            }
          },
          {
            path: 'wb-tmpl',
            name: 'ChatbotWBTmpl',
            component: ChatbotWBTmpl,
            meta: {
              title: 'ChatbotWBTmpl',
              keepAlive: true,
              roles: ['ChatbotWBTmpl']
            },
            showChildren: 'false',
            children: [
              {
                path: 'detail/:id',
                name: 'ChatbotWBTmplDetail',
                component: ChatbotWBTmplEdit,
                hidden: true,
                meta: {
                  title: 'ChatbotWBTmplDetail'
                }
              },
              {
                path: 'add/:id',
                name: 'ChatbotWBTmplAdd',
                component: ChatbotWBTmplEdit,
                hidden: true,
                meta: {
                  title: 'ChatbotWBTmplAdd'
                }
              },
              {
                path: 'edit/:id',
                name: 'ChatbotWBTmplEdit',
                component: ChatbotWBTmplEdit,
                hidden: true,
                meta: {
                  title: 'ChatbotWBTmplEdit'
                }
              }
            ]
          },
          {
            path: 'opt-out',
            name: 'ChatbotOptOut',
            component: ChatbotOptOut,
            meta: {
              title: 'ChatbotOptOut',
              keepAlive: true,
              roles: ['ChatbotOptOut']
            }
          }
        ]
      },
      {
        path: 'chat',
        name: 'ChatbotChat',
        component: ParentView,
        meta: {
          icon: 'icon-qudao-Webchajian',
          title: 'ChatbotChat',
          show: 'false'
        },
        children: [
          {
            path: 'teamInbox',
            name: 'ChatbotTeamInbox',
            component: ChatbotTeamInbox,
            meta: {
              title: 'ChatbotTeamInbox',
              roles: ['ChatbotTeamInbox']
            }
          }
        ]
      },
      {
        path: 'general',
        name: 'ChatbotGeneral',
        component: ParentView,
        meta: {
          icon: 'icon-fuwuyugongju1',
          title: 'ChatbotGeneral',
          show: 'false'
        },
        children: [
          {
            path: 'social',
            name: 'ChatbotSocial',
            component: ChatbotSocial,
            meta: {
              title: 'ChatbotSocial',
              keepAlive: true,
              roles: ['ChatbotSocial']
            }
          },
          {
            path: 'req',
            name: 'ChatbotReq',
            component: ChatbotReq,
            meta: {
              title: 'ChatbotReq',
              keepAlive: true,
              roles: ['ChatbotReq']
            }
          },
          {
            path: 'doc',
            name: 'ChatbotAPI',
            component: ChatbotAPI,
            meta: {
              title: 'ChatbotAPI',
              roles: ['ChatbotAPI'],
              keepAlive: true
            }
          }
        ]
      }
    ]
  },
  // 系统设置
  {
    path: '/systemSet',
    component: Layout,
    name: 'systemSet',
    meta: { title: 'systemsettings', businessType: '', show: 'false' },
    children: [
      {
        path: 'personal',
        component: ParentView,
        meta: { title: 'personalSetting', icon: 'icon-gerenshezhi', show: 'false' },
        children: [
          {
            path: 'personalInfo',
            name: 'personalInfo',
            component: PersonalInfo,
            meta: {
              title: 'personalInfo',
              roles: ['personalInfo']
            }
          },
          {
            path: 'loginInfo',
            name: 'loginInfo',
            component: LoginInfo,
            meta: {
              title: 'loginInfo',
              roles: ['loginInfo']
            }
          }
        ]
      },
      {
        path: 'account',
        component: ParentView,

        meta: { title: 'AccountManage', icon: 'icon-zhanghuguanli', show: 'false' },
        children: [
          // 系统设置 isSetting:是否为系统设置路由
          {
            path: 'corporate',
            name: 'corporate',
            meta: {
              title: 'Corporate',
              roles: ['Corporate'],
              isSetting: true
            },
            component: () => import('@/views/Account/Corporate/index.vue')
          },
          {
            path: 'user',
            name: 'user',
            meta: {
              title: 'UserControl',
              roles: ['UserControl'],
              isSetting: true
            },
            component: () => import('@/views/Account/User/index.vue')
          },
          {
            path: 'role',
            name: 'role',
            meta: {
              title: 'RolePermission',
              roles: ['RolePermission'],
              isSetting: true
            },
            showChildren: 'false',
            children: [
              {
                path: 'role/addRole',
                name: 'addRole',
                hidden: true,
                meta: {
                  activeMenu: '/systemSet/account/role',
                  roles: ['RolePermission'],
                  isSetting: true,
                  title: 'addRole'
                },
                component: () => import('@/views/Account/Role/addEditRole.vue')
              },
              {
                path: 'role/editRole',
                name: 'editRole',
                hidden: true,
                meta: {
                  activeMenu: '/systemSet/account/role',
                  roles: ['RolePermission'],
                  isSetting: true,
                  title: 'editRole'
                },
                component: () => import('@/views/Account/Role/addEditRole.vue')
              },
              {
                path: 'role/oldAddRole',
                name: 'addRoleOld',
                hidden: true,
                meta: {
                  activeMenu: '/systemSet/account/role',
                  roles: ['RolePermission'],
                  isSetting: true,
                  title: 'addRole'
                },
                component: () => import('@/views/Account/Role/oldEditRole.vue')
              },
              {
                path: 'role/oldEditRole',
                name: 'editRoleOld',
                hidden: true,
                meta: {
                  activeMenu: '/systemSet/account/role',
                  roles: ['RolePermission'],
                  isSetting: true,
                  title: 'editRole'
                },
                component: () => import('@/views/Account/Role/oldEditRole.vue')
              }
            ],
            component: () => import('@/views/Account/Role/index.vue')
          }
        ]
      },
      {
        path: 'tools',
        component: ParentView,
        meta: { title: 'servise_tools', icon: 'icon-kehuguanli', show: 'false' },
        children: [
          {
            path: 'releaseNotes',
            name: 'releaseNotes',
            meta: {
              title: 'releaseNotes',
              roles: ['releaseNotes']
            },
            component: () => import('@/views/Tools/Version/index.vue')
          },
          // {
          //   path: 'helpCenter',
          //   name: 'helpCenter',
          //   meta: {
          //     title: 'helpCenter'
          //   },
          //   component: () => import('@/views/Tools/Help/index.vue')
          // },
          {
            path: 'operateWord',
            name: 'operateWord',
            meta: {
              title: 'manual',
              roles: ['operateWord']
            },
            component: () => import('@/views/Tools/Help/operate.vue')
          },
          {
            path: 'apiWord',
            name: 'apiWord',
            meta: {
              title: 'document',
              roles: ['apiWord']
            },
            component: () => import('@/views/Tools/Help/api.vue')
          },
          {
            path: 'Application',
            name: 'Application',
            meta: {
              title: 'Application',
              roles: ['Application']
            },
            component: () => import('@/views/Tools/Application/index.vue')
          },
          {
            path: 'OperatingRecord',
            name: 'OperatingRecord',
            meta: {
              title: 'OperatingRecord',
              roles: ['OperatingRecord']
            },
            component: () => import('@/views/Tools/Record/index.vue')
          }
        ]
      },
      {
        path: 'config',
        component: ParentView,
        meta: { title: 'configCenter', icon: 'icon-peizhizhongxin', show: 'false' },
        children: [
          {
            path: 'accessControl',
            name: 'accessControl',
            meta: {
              title: 'accessControl',
              roles: ['accessControl']
            },
            component: () => import('@/views/ConfigCenter/AccessControl/index.vue')
          }
        ]
      }
    ]
  }
)
export const asyncRoutes = tempRoutes

// 把路由对象暴露出去



// WEBPACK FOOTER //
// ./src/router/index.js